module.exports = __webpack_public_path__ + "media/site_templates/www.cheapplumber.net.au/images/our_services_2-09d333a47d1b122f04bf07cb73f90cac.jpg";